import { Input, Textarea, Label, Button } from '@creanizer/ui'
import { Plus, X } from 'lucide-react'
import { useState } from 'react'
import type { CharacterDailyLife } from '@creanizer/types'

interface DailyLifeEditorProps {
  dailyLife: CharacterDailyLife
  onChange: (dailyLife: CharacterDailyLife) => void
}

export function DailyLifeEditor({
  dailyLife,
  onChange
}: DailyLifeEditorProps) {
  const [newItem, setNewItem] = useState('')

  const handleAddItem = () => {
    if (newItem) {
      onChange({
        ...dailyLife,
        importantItems: [...(dailyLife.importantItems || []), newItem]
      })
      setNewItem('')
    }
  }

  const handleRemoveItem = (index: number) => {
    onChange({
      ...dailyLife,
      importantItems: (dailyLife.importantItems || []).filter((_, i) => i !== index)
    })
  }

  const handleUpdateItem = (index: number, value: string) => {
    const updated = [...(dailyLife.importantItems || [])]
    updated[index] = value
    onChange({
      ...dailyLife,
      importantItems: updated
    })
  }

  return (
    <div className="space-y-4">
      <div>
        <Label htmlFor="routine">日常生活の描写</Label>
        <Textarea
          id="routine"
          value={dailyLife.routine || ''}
          onChange={(e) => onChange({ ...dailyLife, routine: e.target.value })}
          placeholder="例: 朝は早起きして散歩、昼は仕事、夜は読書をして過ごす..."
          rows={4}
          className="mt-1"
        />
      </div>

      <div>
        <Label className="font-medium">重要なアイテム・所有物</Label>
        <div className="space-y-2 mt-2">
          {(dailyLife.importantItems || []).map((item, index) => (
            <div key={index} className="flex gap-2">
              <Input
                value={item}
                onChange={(e) => handleUpdateItem(index, e.target.value)}
                className="flex-1"
              />
              <Button
                size="sm"
                variant="ghost"
                onClick={() => handleRemoveItem(index)}
              >
                <X className="h-4 w-4" />
              </Button>
            </div>
          ))}
          <div className="flex gap-2">
            <Input
              value={newItem}
              onChange={(e) => setNewItem(e.target.value)}
              placeholder="例: 母の形見のペンダント、愛用の剣"
              onKeyPress={(e) => e.key === 'Enter' && handleAddItem()}
              className="flex-1"
            />
            <Button
              size="sm"
              onClick={handleAddItem}
            >
              <Plus className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
